import React, { useState, useEffect, useMemo } from "react";
import "./PapersHome.css";
import "./../typography-home.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ChangePaperModal from "../../PaperFourShiftButtons/PaperSelectModal";
import {
  englishData,
  sinhalaData,
  tamilData,
} from "../../../dummyData/HomeDummyData";

function PapersHome() {
  const navigate = useNavigate();
  const isProUser = useSelector((state) => state.user.isPro);
  const selectedLanguage = useSelector((state) => state.language.language);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [language, setLanguage] = useState(sinhalaData[0]);

  useEffect(() => {
    switch (selectedLanguage.value) {
      case "english":
        setLanguage(englishData[0]);
        break;
      case "tamil":
        setLanguage(tamilData[0]);
        break;
      default:
        setLanguage(sinhalaData[0]);
        break;
    }
  }, [selectedLanguage]);

  const papers = useMemo(
    () => [
      {
        id: 1,
        title: language.paperNo1,
        label: "First Paper",
        value: "first",
        titleKey: "paperNo1",
        isPro: false,
      },
      {
        id: 2,
        title: language.paperNo2,
        label: "Second Paper",
        value: "second",
        titleKey: "paperNo2",
        isPro: false,
      },
      {
        id: 3,
        title: language.paperNo3,
        label: "Third Paper",
        value: "third",
        titleKey: "paperNo3",
        isPro: false,
      },
      {
        id: 4,
        title: language.paperNo4,
        label: "Fourth Paper",
        value: "fourth",
        titleKey: "paperNo4",
        isPro: false,
      },
    ],
    [language],
  );

  const handleOpenPaper = (route) => {
    setTimeout(() => {
      navigate(route);
    });
  };

  const handleSelectPaper = (label, value) => {
    localStorage.setItem("paperLabel", label);
    localStorage.setItem("paperValue", value);
    handleOpenPaper("/paper");
  };

  const handleCloseChangePaperModal = () => {
    setIsModelOpen(false);
  };

  const handleProUserPage = () => {
    navigate("/subscription");
  };

  return (
    <section className="papers-section py-5 min-vh-80 d-flex align-items-center">
      <div className="container text-center text-md-start">
        <h2 className="typography-title fw-bold mb-2">
          {language.PapersTitle}
        </h2>
        <h3 className="fw-semibold text-muted mb-3 typography-subtitle ">
          {language.PapersSubTitle}
        </h3>
        <p className="text-muted mb-5 w-lg-100 w-75 mx-auto typography-paragraph">
          {language.PapersSubTitle2}
        </p>

        <div className="row justify-content-center">
          {papers.map((paper) => (
            <div
              key={paper.id}
              className="col-6 col-sm-4 col-md-3 mb-4"
              onClick={() => {
                handleSelectPaper(paper.label, paper.value);
              }}
            >
              <div className="paper-card p-4 shadow-sm text-center">
                <div className="icon-box mx-auto mb-3">
                  <i
                    className="bi bi-file-earmark-text-fill"
                    alt="Driving license exam papers sri lanka"
                  ></i>
                </div>
                <h6 className="fw-semibold">{paper.title}</h6>
                <div className="underline mx-auto mt-2"></div>
              </div>
            </div>
          ))}
        </div>

        {/* <div className="papers-help-box mt-4 mx-auto">
          <div className="papers-help-icon">
            <i className="bi bi-lightbulb-fill"></i>
          </div>

          <div className="papers-help-content">
            <p className="papers-help-text mb-0">{language.PapersDes}</p>
          </div>
        </div> */}

        <div className="papers-tip-card mt-4 mx-auto">
          {/* <div className="papers-tip-badge">
    <i className="bi bi-stars"></i>
    <span>Exam Tip</span>
  </div> */}

          <div className="papers-tip-body">
            <h6 className="papers-tip-title mb-2">Attention</h6>
            <p className="papers-tip-text mb-0">{language.PapersDes}</p>
          </div>

          {/* <div className="papers-tip-action">
    <button
      type="button"
      className="btn btn-danger btn-sm rounded-pill px-3"
      onClick={() => handleSelectPaper("First Paper", "first")}
    >
      Start Now
    </button>
  </div> */}
        </div>
      </div>
      {isModelOpen && (
        <ChangePaperModal
          showModal={isModelOpen}
          handleClose={handleCloseChangePaperModal}
        />
      )}
    </section>
  );
}

export default PapersHome;
